import _ from 'lodash';

export default class RequestContextService {
  static get() {
    const local = JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
    const session = JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {};
    const context = _.omitBy({ ...local, ...session }, _.isNil);

    return _.isEmpty(context) ? null : context;
  }

  static update(requestContext, persistence = 'local') {
    if (persistence === 'keep-original') {
      const session = _.pick(
        JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {},
        AUTH_PROPERTIES
      );

      persistence = !_.isEmpty(session) ? 'session' : 'local';
    }

    requestContext = _.omitBy(requestContext, _.isNil);

    removeAuthData(localStorage);
    removeAuthData(sessionStorage);

    if (persistence === 'session' || requestContext.isPendingMFA) {
      const data = _.pick(requestContext, AUTH_PROPERTIES);

      if (!_.isEmpty(data)) {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
      }

      requestContext = _.omit(requestContext, AUTH_PROPERTIES);
    }

    const previous = JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
    const data = { ...previous, ...requestContext };

    if (!_.isEmpty(data)) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    }
  }

  static clear() {
    RequestContextService.update({}, 'local');
    RequestContextService.update({}, 'session');
  }
}

const AUTH_PROPERTIES = [
  'authToken',
  'authTokenExpirationDate',
  'refreshToken',
  'user',
  'isPendingMFA',
  'signInMethod',
  'phone'
];
const STORAGE_KEY = 'request-context';

const removeAuthData = storage => {
  if (storage.getItem(STORAGE_KEY)) {
    const data = _.omit(JSON.parse(storage.getItem(STORAGE_KEY)), AUTH_PROPERTIES);

    if (_.isEmpty(data)) {
      storage.removeItem(STORAGE_KEY);
    } else {
      storage.setItem(STORAGE_KEY, JSON.stringify(data));
    }
  }
};
